import { Link } from "react-router-dom";
import "./Footer.css";
export function Footer(){
    return(
        <div>
           <footer className="footer">
                <div className="footer-section">
                    <div className="title">
                        <h5>About</h5>
                        <p className="me-5">At Zeenat Mobile Shop, we understand the importance of staying connected in today’s fast-paced world. That’s why we are dedicated to providing our customers with the latest smartphones, tablets, and wearable devices from leading brands. Whether you’re looking for cutting-edge technology or budget-friendly options, we have something for everyone.</p>
                    </div>
                    <div className="title">
                        <h5>Contact</h5>
                        <p>Chakand Bazar, Devi Sthan Rd, Near India No. ATM, Chakand, Gaya, Bihar, India, 804404</p>
                        <div>
                            <a className="bi bi-phone text-black" href="tel:+918409988313"> +918409988313</a>
                        </div>
                        <div>
                            <a className="bi bi-envelope-paper-heart-fill text-black" href="mailto:zeenat.mobile.shop.ejaz@gmail.com"> zeenat.mobile.shop.ejaz@gmail.com</a>
                        </div>
                    </div>
                    <div className="title">
                        <h5>Categories</h5>
                        <ul className="list-unstyled">
                            <li>Mobile</li>
                            <li>Headphones</li>
                            <li>Smart Watches</li>
                            <li>Bluetooth Speakers</li>
                            <li>Wirless Earbuds</li>
                            <li>Charger and</li>
                            <li>Mobile Accessories</li>
                        </ul>
                    </div>
                    <div className="title">
                        <h5>Pages</h5>
                        <ul className="list-unstyled">
                            <li><Link className="text-decoration-none text-black">Home</Link></li>
                            <li><Link className="text-decoration-none text-black">Privacy Policy</Link></li>
                            <li><Link className="text-decoration-none text-black">Returns</Link></li>
                            <li><Link className="text-decoration-none text-black">About</Link></li>
                            <li><Link className="text-decoration-none text-black">Terms & Conditions</Link></li>
                            <li><Link className="text-decoration-none text-black">Contact Us</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="footer-bar">
                        <div>
                            <p>Copyright &copy; 2024 Zeenat Mobile Shop Created with ❣️ by Md Matloob Alam. All Rights Reserved.</p>
                        </div>
                    </div>
           </footer>
        </div>
    )
}
